import { render, staticRenderFns } from "./RestartUpdateBtn.vue?vue&type=template&id=e0593c6a"
import script from "./RestartUpdateBtn.vue?vue&type=script&lang=js"
export * from "./RestartUpdateBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports